import { useEffect, useState } from "react";
import { onSyncChange } from "@/lib/sync";
import { CloudOff, Cloud, RefreshCcw } from "lucide-react";

/**
 * Tiny status pill that shows offline/online + queued count.
 * Sits in the top bar so kitchen staff always know where they stand.
 */
export default function OfflinePill() {
  const [state, setState] = useState({
    online: typeof navigator !== "undefined" ? navigator.onLine : true,
    pending: 0,
    syncing: false,
  });

  useEffect(() => onSyncChange(setState), []);

  if (state.online && state.pending === 0 && !state.syncing) {
    return (
      <div
        data-testid="offline-pill"
        className="hidden md:flex items-center gap-2 text-[11px] uppercase tracking-widest text-eucalyptus-100 px-3 h-9 rounded-md bg-eucalyptus-700/60"
        title="All records synced"
      >
        <Cloud className="w-3.5 h-3.5" />
        Synced
      </div>
    );
  }

  if (!state.online) {
    return (
      <div
        data-testid="offline-pill"
        className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-white px-3 h-9 rounded-md bg-ochre-600"
        title="Offline · changes will sync when you're back online"
      >
        <CloudOff className="w-3.5 h-3.5" />
        Offline
        {state.pending > 0 && (
          <span className="font-mono">· {state.pending} queued</span>
        )}
      </div>
    );
  }

  // online, but syncing or has pending
  return (
    <div
      data-testid="offline-pill"
      className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-white px-3 h-9 rounded-md bg-[#D69F3C]"
      title="Syncing queued records…"
    >
      <RefreshCcw className={`w-3.5 h-3.5 ${state.syncing ? "animate-spin" : ""}`} />
      Syncing · {state.pending}
    </div>
  );
}
